import React from "react";
import styled from "styled-components";
import FaPlay from 'react-icons/lib/fa/play'
import Image from '../../video/imageForVideo.jpg';
import Mouse from '../../components/mouse/mouse.component';

export default class BannerHome extends React.Component{
    render() {
        const {t, i18n} = this.props;
        // TO DO
        return(
            <BannerHomeContent>
                <Overlay></Overlay>
                <ContentVideo>
                    <h1>{t('PROVE PORTUGAL')}</h1>
                    <h2>{t('Pretende dar a conhecer os locais onde a')}<span> {t('Gastronomia Portuguesa')}</span> {t('pode ser saboreada')}</h2>
                    {
                        i18n.language === 'pt' ?
                            <a href="https://www.youtube.com/watch?v=5revE_ChYWo" target="_blank" rel="noopener noreferrer">
                                <Button className="btnOuline"><span><FaPlay/></span>{t('Ver Video')}</Button>
                            </a>
                            :
                            <a href="https://www.youtube.com/watch?v=hR0ITLPTsw8" target="_blank" rel="noopener noreferrer">
                                <Button className="btnOuline"><span><FaPlay/></span>{t('Ver Video')}</Button>
                            </a>
                    }
                </ContentVideo>
                <Mouse/>
            </BannerHomeContent>
        )
    }
}

const BannerHomeContent = styled.div `
    widht: 100%;
    height: 100vh;
    background-image: url(${Image});
    background-size: cover;
`
const Overlay = styled.div `
    width: 100vw;
    height: 100vh;
    position: absolute;  
    top: 0;
    background-color: rgba(0,0,0,0.2);
`
const ContentVideo = styled.div `
    position: absolute;  
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    h1 {
        font-size: 82px;
        color: #FFFFFF;
        font-family: Bazar;
        letter-spacing: 8px;

        @media screen and (max-width: 991px) {
            font-size: 60px;
        } 
    }

    h2 {
        text-align: center;
        max-width: 500px;
        color: #FFFFFF;
        font-size: 24px;
        margin-left: auto;
        margin-right: auto;
        font-weight: normal;

        @media screen and (max-width: 991px) {
            font-size: 20px;
        } 
    }

    h2 span {
        font-weight: bold;
    }
`
const Button = styled.div `
    margin-left: auto;
    margin-right: auto;
    padding: 15px 20px;
    border-radius: 5px;
    border: 1px solid #FFF;
    color: #FFF;
    transition: all 0.3s ease;
    max-width: 220px;
    margin-top: 30px;
    cursor: pointer;
    text-transform: uppercase;

    span {
        margin-right: 20px;
        font-size: 21px;
    }

    &:hover{
        color: #000;
        background-color: #FFF;
    }
`



// WEBPACK FOOTER //
// ./src/components/bannerHome/bannerHome.component.js